import styled from 'styled-components';
import playBtn from '../../imgs/svgs/playBtn.svg';

export const HeroWrapper = styled.div`
  position: relative;
`;

export const HeroDiv = styled.div`
  transition: all 1s ease;

  padding: var(--global-padding) calc(var(--global-padding) * 2);
  overflow: hidden;

  background: url(${(props) => props.bg});

  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  position: relative;

  .movie-info {
    color: var(--white);
    z-index: 4;
    position: relative;

    p {
      margin-bottom: var(--global-margin);
    }
  }

  .img-wrapper {
    margin-top: 1rem;
    z-index: 4;
    border: 0.25rem solid;
    border-image: linear-gradient(var(--gradient)) 1;
    box-shadow: 0 1rem 2rem -1rem rgba(0, 0, 0, 0.8);
    max-width: 280px;
    line-height: 0;
    position: relative;
    overflow: hidden;

    cursor: ${(props) => {
      return props.hasTrailer === true ? 'pointer' : 'auto';
    }};
    img {
      width: 100%;
      object-fit: cover;
    }

    &::after {
      display: ${(props) => {
        return props.hasTrailer !== false ? 'block' : 'none';
      }};
      content: '';
      height: 4rem;
      width: 4rem;
      padding: 2rem;
      background: rgba(0, 0, 0, 0.5) url(${playBtn}) no-repeat;
      background-position: center;
      background-size: 60%;
      border-radius: 50%;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 50;
    }
  }

  &::before {
    content: '';
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);

    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
  }

  .btns {
    display: flex;
  }

  .rating {
    background: linear-gradient(var(--gradient));
    border-radius: 50%;
    width: 4rem;
    height: 4rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 1rem;
    font-weight: bold;
    font-size: 1.25rem;
    /* border: 0.25rem solid;
    border-image: linear-gradient(var(--gradient)) 1; */
    position: relative;

    span {
      position: relative;
      z-index: 10;
    }

    &::after {
      position: absolute;
      z-index: 2;
      content: '';
      background-color: var(--black);
      width: 90%;
      height: 90%;
      border-radius: 50%;
    }
  }

  @media screen and (min-width: 768px) {
    display: flex;
    justify-content: space-around;
    align-items: center;
    max-height: 680px;
    height: 80vh;

    .movie-info {
      width: 45%;
    }
  }

  .rating {
    margin: 0 0 1rem 0;
  }
`;
